import { service } from './service'

import { config } from './config'

const { default_headers } = config

type RequestOption = {
  url: string
  data?: unknown
  params?: Record<string, unknown>
  headers?: Record<string, string>
  headersType?: string
  responseType?: 'blob' | 'arraybuffer'
}

const request = (option: RequestOption & { method: string }) => {
  const { headersType, headers, ...otherOption } = option
  return service({
    ...otherOption,
    headers: {
      'Content-Type': headersType || default_headers,
      ...headers
    }
  })
}
export default {
  get: async <T = unknown>(option: RequestOption) => {
    const res = await request({ method: 'GET', ...option })
    return res.data as unknown as T
  },
  post: async <T = unknown>(option: RequestOption) => {
    const res = await request({ method: 'POST', ...option })
    return res.data as unknown as T
  },
  postOriginal: async (option: RequestOption) => {
    const res = await request({ method: 'POST', ...option })
    return res
  },
  delete: async <T = unknown>(option: RequestOption) => {
    const res = await request({ method: 'DELETE', ...option })
    return res.data as unknown as T
  },
  put: async <T = unknown>(option: RequestOption) => {
    const res = await request({ method: 'PUT', ...option })
    return res.data as unknown as T
  },
  download: async <T = Blob>(option: RequestOption) => {
    const res = await request({ method: 'GET', responseType: 'blob', ...option })
    return res as unknown as Promise<T>
  },
  upload: async <T = unknown>(option: RequestOption) => {
    option.headersType = 'multipart/form-data'
    const res = await request({ method: 'POST', ...option })
    return res as unknown as Promise<T>
  }
}
